export default function() {
  return (input) => {
    // El-1819 hot fix to strip out HTML from description field
    return input.replace(/[<>\n\r]/g, '')
  }
}
